export default __webpack_public_path__ + "ad5f16d72d3a57a3a70ba5a484111653.png";